export default __webpack_public_path__ + "static/media/sports.605f6d71.svg";